module.exports = "<div class=\"dropletBubble-fieldContainer\">\n  <label :for=\"'hide-' + activeDroplet._id\" class=\"dropletBubble-checkLabel\">\n    {{ option.label }}\n  </label>\n  <input\n    :id=\"'hide-' + activeDroplet._id\"\n    class=\"dropletBubble-checkbox\"\n    type=\"checkbox\"\n    v-model=\"display[option.payload.models.value.name]\"\n    @change=\"changeCSS(option.payload)\" />\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/page/style-sidebar/options/checkbox/template.html
// module id = pJ2y
// module chunks = 0